import { createReducer, on } from '@ngrx/store';
import { sessionActions } from '../actions/session.actions';
import { User } from '../models';

export interface SessionState {
    loaded: boolean | null;
    loading: boolean | null;
    user: User | null;
}

export const initialState: SessionState = {
    loaded: null,
    user: null,
    loading: null,
};

export const sessionReducer = createReducer(
    initialState,
    on(sessionActions.getSession, (state): SessionState => ({
        ...state,
        loading: true,
        loaded: null,
    })),
    on(sessionActions.getSessionSuccess, (state, { payload }): SessionState => ({
        ...state,
        loading: false,
        loaded: true,
        user: payload,
    })),
    on(sessionActions.getSessionError, (state): SessionState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    on(sessionActions.clear, (): SessionState => ({
        ...initialState,
    })),
);
